// extracted by mini-css-extract-plugin
export default {"avatar":"avatar__W14HP","circle":"circle__AsxL0","square":"square__TCQw0","keyword":"keyword__fWdV8","hashtag":"hashtag__PLzsK"};